import React from 'react'

import styles from './FormCombinedBlocks.module.scss'

const FormCombinedBlocks = ({ children }) => <ul className={styles.formCombinedBlocks}>{children}</ul>

export default FormCombinedBlocks
